import { type ListDropdownItem } from '@sr/types';
import { type PartnerInfo } from 'core/lib/types';

const partnerDetailsToDropdownItem = (details: PartnerInfo, appendChildCount = true) =>
  ({
    label:
      details.name +
      (details.childCount > 0 && appendChildCount ? ` (+${details.childCount})` : ''),
    value: details.dwKey,
    type: 'value',
    children: [],
    meta: {
      id: details.id,
      description: `${details.description || details.name}, ${
        details.address.street && details.address.street + ', '
      }${details.address.city}, ${details.id}`,
    },
  }) as ListDropdownItem;

export default partnerDetailsToDropdownItem;
